import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";

interface CampaignTypeInfoContentProps {
  technicalCode: string;
  description: string;
  objetivo: string;
  caracteristicas: string[];
  regras: string[];
}

export function CampaignTypeInfoContent({
  technicalCode,
  description,
  objetivo,
  caracteristicas,
  regras,
}: CampaignTypeInfoContentProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Badge variant="outline">{technicalCode}</Badge>
        <span className="text-sm">{description}</span>
      </div>

      <div>
        <h4 className="font-semibold text-sm mb-2">
          Objetivo
        </h4>
        <p className="text-sm text-muted-foreground">
          {objetivo}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-sm mb-2">
          Características
        </h4>
        <ul className="space-y-2">
          {caracteristicas.map((item, idx) => (
            <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
              <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-sm mb-2">
          Regras de Negócio
        </h4>
        <ul className="space-y-2">
          {regras.map((regra, idx) => (
            <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
              <span className="text-primary mt-0.5">•</span>
              <span>{regra}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
